import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ServiceName } from '../model/serviceName';
import { INAAction } from '../../model/ina-action';
import { LstQuestionValueDataView, Question, Section } from '../model/inaSchoolEnrollments';
import { Shared } from '../../service/shared';
import { InaService } from '../../service/ina.service';
import { StepAction } from '../model/stepAction';
import { TrackingHistories, TrackingHistory } from '../../service/history';
import { InaSchoolEnrollment2 } from '../../model/ina-school-enrollment-sections';
import { ServiceAdministrationService } from 'src/app/component/service-administration/service/service-administration.service';



@Component({
  selector: 'app-secondary',
  templateUrl: './secondary.component.html',
  styleUrls: ['./secondary.component.scss']
})

export class SecondaryComponent implements OnInit {
  @Input('step') step: number;
  @Input('action') action: INAAction;
  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() valid = new EventEmitter<boolean>();
  @Output() updateHistory = new EventEmitter<TrackingHistory>();

  frmSecondary: UntypedFormGroup;
  section: Section;
  inaSchoolEnrollment: InaSchoolEnrollment2;
  shared: Shared;
  notifyAction: string = '';
  inaStatusTypeId: number;

  lookupMepService: ServiceName[] = [];
  lstMepService: ServiceName[] = [];
  mepServiceQuestions: Question[];

  lYear: string = ''; lGrade: string = '';
  mYear: string = ''; mGrade: string = '';
  eYear: string = ''; eGrade: string = '';



  panelOpenState: boolean = false;
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();

  constructor(
    private fb: UntypedFormBuilder,
    public serviceAdministration: ServiceAdministrationService,
    private inaService: InaService
  ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];
    this.frmSecondary = this.fb.group({
      radioArtStandardMet: [],
      radioMathStandardMet: [],
      radioProficient: [],
      languageComments: [],
      radioUnaddressedCreditDeficiency: ['', Validators.required],
      unaddressedComments: []

    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.fireValidation();
    }, 3000)
  }
  fireValidation() {
    if (this.action != INAAction.View) {
      if (this.radioUnaddressedCreditDeficiency.errors?.required) {
        this.radioUnaddressedCreditDeficiency.setErrors({ required: true, invalid: 'Select Yes/No' })
        this.frmSecondary.setErrors({ required: true, invalid: '' });
      }
      else if (this.radioUnaddressedCreditDeficiency.value == "1" && this.lstMepService.length <= 0) {
        this.frmSecondary.setErrors({ required: true, invalid: 'Select atleast one MEP Services' });
      }
      else {
        this.frmSecondary.setErrors(null);
      }
      let validator: boolean = (this.frmSecondary.errors?.['required'] == true) ? false : true;
      this.valid.emit(validator);
    }
  }

  ngOnInit(): void {
    let sectionId: number = 23;
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.inaSchoolEnrollment = x.inaSchoolEnrollment.InaSchoolEnrollment;
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
      if (!this.frmSecondary.dirty) {
        this.frmSecondary.reset();
        this.setFormValue();
      }
    });
    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });


    if (this.action == INAAction.View) {
      this.frmSecondary.disable();
    }
    else {
      this.radioArtStandardMet.disable();
      this.radioMathStandardMet.disable();
      this.radioProficient.disable();
      this.changeDetection();
      this.frmSecondary.valueChanges.subscribe(() => {
        this.updateChangeValue();
      })

    }

    this.mepServiceQuestions = this.getQuestions('Recommended MEP Services');

    this.invokeRecommendedMEPService();
  }
  invokeRecommendedMEPService() {
    let payLoad = '';
    if (this.action == 3) {
      payLoad = '{"regionID":' + this.inaSchoolEnrollment.RegionId + ',"grades":[' + this.inaSchoolEnrollment.GradeId + '],"checkAllGrades":true,"creditAccrualOnly":true}';
    }
    else {
      payLoad = '{"regionID":' + this.inaSchoolEnrollment.RegionId + ',"activeServicesOnly":true,"grades":[' + this.inaSchoolEnrollment.GradeId + '],"checkAllGrades":true,"creditAccrualOnly":true}';
    }
    this.serviceAdministration.postIndex(payLoad).subscribe(x => {
      this.lookupMepService = JSON.parse(x['partyServices']);
      if (this.mepServiceQuestions?.length > 0) {
        let serviceIds = this.mepServiceQuestions[0].lstQuestionValueDataView[0].Value.split(',')
        serviceIds.forEach(id => {
          let a = this.lookupMepService.find(lookupService => lookupService.ID.toString() == id);
          if (a) {
            this.lstMepService.push(a);
          }
        });
      }

    });
  }

  setFormValue() {
    this.getListQuestionValueData(347, 'Language Arts').forEach(
      x => {
        if (x.Name == 'Language Arts Year')
          this.lYear = x.Value;
        else if (x.Name == 'Assessed Grade')
          this.lGrade = x.Value;
        else if (x.Name == 'Standard Met or Exceeded' && this.lYear.length > 0) {
          if (x.Value == 'True')
            this.radioArtStandardMet.setValue("1");
          if (x.Value == 'False')
            this.radioArtStandardMet.setValue("2");

        }

      }
    );

    this.getListQuestionValueData(351, 'Math').forEach(
      x => {
        if (x.Name == 'Math Year')
          this.mYear = x.Value;
        else if (x.Name == 'Assessed Grade')
          this.mGrade = x.Value;
        else if (x.Name == 'Standard Met or Exceeded' && this.mYear.length > 0) {
          if (x.Value == 'True')
            this.radioMathStandardMet.setValue("1");
          if (x.Value == 'False')
            this.radioMathStandardMet.setValue("2");

        }
      }
    );

    this.getListQuestionValueData(355, 'ELPAC').forEach(
      x => {
        if (x.Name == 'ELPAC Year')
          this.eYear = x.Value;
        else if (x.Name == 'Assessed Grade')
          this.eGrade = x.Value;
        else if (x.Name == 'Proficient' && this.eYear.length > 0) {
          if (x.Value == 'True')
            this.radioProficient.setValue("1");
          if (x.Value == 'False')
            this.radioProficient.setValue("2");

        }          
      }
    );

    this.languageComments.setValue(this.getQuestionValue(359, 'Assessment Comments'));

    this.getListQuestionValueData(360, 'Unaddressed Credit Deficiency?').forEach
      (
        x => {
          if (x.Name == 'Yes' && x.Value == "True")
            this.radioUnaddressedCreditDeficiency.setValue("1");
          if (x.Name == 'No' && x.Value == "True")
            this.radioUnaddressedCreditDeficiency.setValue("2");
        }
      );

    this.unaddressedComments.setValue(this.getQuestionValue(364, 'Credit Deficient Comments'));


  }

  changeDetection() {
    this.radioUnaddressedCreditDeficiency.valueChanges.subscribe((x: any) => {
      if (x == "1") {
        this.fireValidation();
      }
    })
  }

  getListQuestionValueData(questionId: number, questionName: string): LstQuestionValueDataView[] {
    {
      return this.shared.getListQuestionValueData(this.section, questionId, questionName);
    }

  }
  getQuestionValue(questionId: number, questionName: string): string {
    return this.shared.getQuestionValue(this.section, questionId, questionName);
  }


  remove(p: ServiceName) {
    this.lstMepService = this.lstMepService.filter(obj => obj.ID !== p.ID)
    if (this.IdentifyChange()) {
      this.updateMEPChangeValue();
    }
  }
  pOpenState(pState: any) {
    this.panelOpenState = pState;
    if (!this.panelOpenState && this.IdentifyChange()) {
      this.updateMEPChangeValue();
    }

  }

  getQuestions(matchquery: string): Question[] {
    let tempRetQuestion = this.section.Questions.filter(x => x.Name.toString().match(matchquery)).filter(y => y.lstQuestionValueDataView[0].Value != "");
    return tempRetQuestion;
  }

  /* setStep(index: number) {
     this.step = index;
     let s: StepAction = new StepAction();
     s.stepNumber = this.step;
     this.prevOrNextStep.emit(s);
   }
 
   nextStep() {
     this.notifyAction = 'Next';
     this.notifyChanges(0);
   }
 
   prevStep() {
     this.notifyAction = 'Prev';
     this.notifyChanges(0);
   }
 
   notifyChanges(action: number) {
       let s: StepAction = new StepAction();
       s.stepNumber = 6;
       s.action = action == 1 ? '': this.notifyAction ;
       s.section = new Section();
       if (this.frmSecondary.dirty) {
         this.updateChangeValue();
         s.section = this.section;
         s.lsttrackingHistory = this.lstTrackHistory;      
         this.lstTrackHistory=[];
       }
       this.prevOrNextStep.emit(s);
 
   }
       */
  updateChangeValue() {
    if (this.radioArtStandardMet.dirty) {
      let radioVal: string = '';
      radioVal = this.radioArtStandardMet.value == 1 ? "True" : this.radioArtStandardMet.value == 2 ? "False" : "";
      this.setListQuestionValue(347, 'Standard Met or Exceeded', radioVal);
    }
    if (this.radioMathStandardMet.dirty) {
      let radioVal: string = '';
      radioVal = this.radioMathStandardMet.value == 1 ? "True" : this.radioMathStandardMet.value == 2 ? "False" : "";
      this.setListQuestionValue(351, 'Standard Met or Exceeded', radioVal);
    }
    if (this.radioProficient.dirty) {
      let radioVal: string = '';
      radioVal = this.radioProficient.value == 1 ? "True" : this.radioProficient.value == 2 ? "False" : "";
      this.setListQuestionValue(355, 'Proficient', radioVal);

    }
    if (this.languageComments.dirty) {
      this.setListQuestionValue(359, 'Assessment Comments', this.languageComments.value);
    }

    if (this.radioUnaddressedCreditDeficiency.dirty) {
      let radioVal: string = '';
      radioVal = this.radioUnaddressedCreditDeficiency.value
      this.setRadioValue(360, 'Yes', radioVal);
    }

    if (this.unaddressedComments.dirty) {
      this.setListQuestionValue(364, 'Credit Deficient Comments', this.unaddressedComments.value);
    }

  }
  updateMEPChangeValue() {
    this.section.Questions.forEach(x => {
      if (x.Id == 363) {
        let ids = this.lstMepService.map((x => x.ID));
        x.lstQuestionValueDataView[0].Value = ids.toString();
      }
    })
    this.shared.updateSections(this.section, 0);
    this.shared.updateCacheSection(this.section);
    this.fireValidation();
  }
  IdentifyChange(): boolean {
    let returnVal: boolean = false;
    this.section.Questions.forEach(quest => {
      if (quest.Id == 363) {
        let prevValueIds = quest.lstQuestionValueDataView[0].Value.split(',');
        if (prevValueIds.length == 1 && prevValueIds[0] == '') {
          prevValueIds = [];
        }
        let newValueIds = this.lstMepService.map((x => x.ID.toString()));

        const deletedIds = prevValueIds.filter(x => !newValueIds.includes(x));
        if (deletedIds.length >= 1) {
          let changedField: string = this.section.SectionID + ',' + quest.Id;
          let deletedServiceName: string[] = this.findModifiedServiceName(deletedIds);
          this.setTrackingHistoryMEPField(changedField, 'Deleted ', deletedServiceName);
          returnVal = true;
        }

        const newIds = newValueIds.filter(x => !prevValueIds.includes(x));
        if (newIds.length >= 1) {
          let changedField: string = this.section.SectionID + ',' + quest.Id;
          let newServiceName: string[] = this.findModifiedServiceName(newIds);
          this.setTrackingHistoryMEPField(changedField, 'Added ', newServiceName);
          returnVal = true;
        }
      }
    })

    return returnVal;
  }
  setRadioValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setRadioValue(this.section, questionId, value);
    this.fireValidation();
  }

  setListQuestionValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setListQuestionValue(this.section, questionId, questionName, value);
    this.fireValidation();
  }
  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }
  setTrackingHistoryMEPField(changedField: string, action: string, deletedIds: string[]) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTracking(changedField, action, deletedIds);
      this.updateHistory.emit(tempTrackingHistory);
    }
  }
  findModifiedServiceName(deletedIds: string[]): string[] {
    const obj: string[] = [];
    this.lookupMepService.map((s: ServiceName) => {
      deletedIds.map((id: string) => {
        if (Number(id) == s.ID) {
          obj.push(s.SERVICE_NAME);
        }
      });

    });
    return obj;
  }

  get radioArtStandardMet(): any { return this.frmSecondary.get('radioArtStandardMet'); }
  get radioMathStandardMet(): any { return this.frmSecondary.get('radioMathStandardMet'); }
  get radioProficient(): any { return this.frmSecondary.get('radioProficient'); }

  get languageComments(): any { return this.frmSecondary.get('languageComments'); } //AssessmentComments
  get radioUnaddressedCreditDeficiency(): any { return this.frmSecondary.get('radioUnaddressedCreditDeficiency'); }
  get unaddressedComments(): any { return this.frmSecondary.get('unaddressedComments'); } //creditDeficientComments


  /*export interface PeriodicElement {
    name: string;
    position: number;
  
  }*/

}